function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { Children, cloneElement, useImperativeHandle, forwardRef, useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Panel from '../Panel/Panel';
import { useListFocus } from '@nt/dds-utils';
var SubMenu = forwardRef(function (props, ref) {
  var children = props.children,
    width = props.width,
    left = props.left,
    top = props.top,
    isOpen = props.isOpen,
    focusIndex = props.focusIndex;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var panelRef = useRef(null);
  useImperativeHandle(ref, function () {
    return panelRef.current;
  });
  useEffect(function () {
    var items = [];
    if (panelRef.current) {
      items = panelRef.current.querySelectorAll('[role="menuitem"]');
    }
    setItems(Array.from(items));
  }, [panelRef, isOpen]);
  var setFocus = function setFocus(item) {
    item.focus();
  };
  useListFocus(panelRef, '[role="menuitem"]', isOpen, setFocus, items, focusIndex);
  return /*#__PURE__*/React.createElement(Panel, {
    ref: panelRef,
    className: "paddingtop-md paddingbottom-md position-fixed",
    noPadding: true,
    isOpen: isOpen,
    width: width,
    height: "auto",
    left: left,
    top: top
  }, /*#__PURE__*/React.createElement("ul", {
    role: "menu"
  }, Children.map(children, function (child) {
    return cloneElement(child, {
      onClick: function onClick(e) {
        e.stopPropagation();
        child.props.onClick();
      },
      className: 'submenu__item'
    });
  })));
});
SubMenu.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isOpen: PropTypes.bool,
  focusIndex: PropTypes.number
};
SubMenu.displayName = 'SubMenu';
export default SubMenu;